/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RegisterCardResponse as AgentApiContractRegisterCardResponse } from '../../models/AgentApi/Contract/register-card-response';
import { ConfirmData as AgentApiControllersConfirmData } from '../../models/AgentApi/Controllers/confirm-data';

export interface ApiAgentRegisterCardSmsConfirmPost$Params {

/**
 * Interface language
 */
  lang?: string;
      body?: AgentApiControllersConfirmData
}

export function apiAgentRegisterCardSmsConfirmPost(http: HttpClient, rootUrl: string, params?: ApiAgentRegisterCardSmsConfirmPost$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractRegisterCardResponse>> {
  const rb = new RequestBuilder(rootUrl, apiAgentRegisterCardSmsConfirmPost.PATH, 'post');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AgentApiContractRegisterCardResponse>;
    })
  );
}

apiAgentRegisterCardSmsConfirmPost.PATH = '/api/Agent/RegisterCardSMSConfirm';
